"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { track } from "@vercel/analytics";
import { Share, Users } from "lucide-react";
import { SharePopup } from "@/components/share-popup";
import { requestFullscreen } from "@/lib/fullscreen";
import { useSession } from "@/hooks/use-session";

export function ShareInviteCard() {
  const [isShareOpen, setIsShareOpen] = useState(false);
  const { session } = useSession();

  if (!session?.id) {
    return null;
  }

  return (
    <>
      <Card className="rounded-2xl border-dashed border-2 border-secondary-foreground/20 bg-secondary/30">
        <CardHeader className="pb-2">
          <div className="flex items-start gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-foreground/10">
              <Users className="h-5 w-5 text-secondary-foreground" />
            </div>
            <div className="min-w-0 flex-1">
              <CardTitle className="text-lg leading-tight">Invite a Friend</CardTitle>
              <CardDescription className="mt-1 text-sm leading-relaxed">
                Share the scavenger hunt with friends and colleagues!
              </CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="pt-0">
          <Button
            onClick={() => {
              track("share_opened", { location: "invite_card" });
              void requestFullscreen();
              setIsShareOpen(true);
            }}
            variant="outline"
            className="h-12 w-full rounded-xl text-base font-medium border-secondary-foreground/20 hover:bg-secondary-foreground/5"
          >
            <Share className="mr-2 size-7 shrink-0" strokeWidth={1.5} />
            Share Hunt
          </Button>
        </CardContent>
      </Card>

      <SharePopup
        open={isShareOpen}
        onOpenChange={setIsShareOpen}
        sessionId={session.id}
      />
    </>
  );
}
